import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { colors } from 'common/constants';

type BaseInputNumberProps = TextFieldProps & {
    name: string;
};

const BaseInputNumber: React.FC<BaseInputNumberProps> = ({
    name,
    ...props
}) => {
    return (
        <Controller
            name={name}
            render={({ field, fieldState: { error } }) => (
                <>
                    <NumericFormat
                        {...field}
                        fullWidth
                        autoComplete="off"
                        placeholder={props.placeholder}
                        customInput={TextField}
                        onChange={(e) => {
                            field.onChange(
                                e.target.value ? Number(e.target.value) : null
                            );
                        }}
                        decimalScale={0}
                        allowLeadingZeros={false}
                        allowNegative={false}
                        error={!!error}
                        helperText={error && error.message}
                        FormHelperTextProps={{
                            sx: {
                                fontSize: '14px',
                                marginLeft: 0,
                                color: `${colors.textError} !important`,
                                fontWeight: '400',
                            },
                        }}
                        disabled={props.disabled}
                        sx={{ ...props.sx }}
                    />
                </>
            )}
        />
    );
};

export default BaseInputNumber;
